import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";
const VirtualAgent = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/software/jira/service-management/features/itsm/virtual-agent"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.VirtualAgent.header",
            defaultMessage: "Virtual agent"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.VirtualAgent.body",
            defaultMessage:
                "The virtual agent automates Tier 1 support interactions in Slack (Microsoft Teams coming soon), and uses artificial intelligence to generate responses to service requests using your existing knowledge base."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.VirtualAgent.link",
                defaultMessage:
                    "<learnMore>Learn more about virtual agent.</learnMore>"
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default VirtualAgent;
